/**
 * Navigation Translations Configuration
 * 
 * This file maps Ghost Admin navigation items to their translations.
 * 
 * IMPORTANT: 
 * - Keys must match EXACTLY what you enter in Ghost Admin navigation URLs
 * - If Ghost Admin has: http://localhost:2368/themen/
 * - Then the key should be: "/themen/"
 * - NOT "/en/themen/" or "/de/themen/"
 * 
 * Structure:
 * {
 *   "/base-url-from-ghost-admin/": {
 *     "en": { "label": "English Name", "url": "/en/translated-path/" },
 *     "de": { "label": "German Name", "url": "/de/translated-path/" }
 *   }
 * }
 */

window.navigationTranslations = {
    // Example 1: /themen/ route (MUST match Ghost Admin URL exactly)
    // Ghost Admin: Label: "Themen", URL: "http://localhost:2368/themen/"
    "/themen/": {
        "en": {
            "label": "Themes",
            "url": "/en/themes/"
        },
        "de": {
            "label": "Themen",
            "url": "/de/themen/"
        }
    },
    "/buecher/": {
        "en": {
            "label": "Books",
            "url": "/en/books/"
        },
        "de": {
            "label": "Bücher",
            "url": "/de/buecher/"
        }
    },
    "/videos/": {
        "en": {
            "label": "Videos",
            "url": "/en/videos/"
        },
        "de": {
            "label": "Videos",
            "url": "/de/videos/"
        }
    },
    "/autor/": {
        "en": {
            "label": "Author",
            "url": "/en/author/"
        },
        "de": {
            "label": "Autor",
            "url": "/de/autor/"
        }
    },
    //secondary navigation
     "/impressum/": {
        "en": {
            "label": "Contact",
            "url": "/en/contact/"
        },
        "de": {
            "label": "Impressum",
            "url": "/de/impressum/"
        }
    },
    "/datenschutzerklaerung/": {
        "en": {
            "label": "Privacy",
            "url": "/en/privacy/"
        },
        "de": {
            "label": "Datenschutzerklärung",
            "url": "/de/datenschutzerklaerung/"
        }
    },
     "/hilfe/": {
        "en": {
            "label": "Help",
            "url": "/en/help/"
        },
        "de": {
            "label": "Hilfe",
            "url": "/de/hilfe/"
        }
    },

    
    // Example 5: Tag-based navigation
    // Ghost Admin: Label: "News", URL: "http://localhost:2368/tag/news/"
    "/tag/news/": {
        "en": {
            "label": "News",
            "url": "/tag/news-en/"
        },
        "de": {
            "label": "Nachrichten",
            "url": "/tag/news-de/"
        }
    },
    
    // Home - usually doesn't need translation but included for completeness
    // Ghost Admin: Label: "Home", URL: "http://localhost:2368/"
    "/": {
        "en": {
            "label": "Home",
            "url": "/"
        },
        "de": {
            "label": "Startseite",
            "url": "/"
        }
    },
     "/checkout/": {
        "en": {
            "label": "Checkout",
            "url": "/checkout/"
        },
        "de": {
            "label": "Zahlung",
            "url": "/checkout/"
        }
    }
};

/**
 * HOW TO USE - STEP BY STEP:
 * 
 * 1. In Ghost Admin → Settings → Navigation, add item:
 *    Label: "Themen"
 *    URL: "http://localhost:2368/themen/"
 *    
 *    NOTE: The URL should be a BASE URL without /en/ or /de/ prefix!
 * 
 * 2. Copy the path part of the URL (everything after the domain):
 *    From: "http://localhost:2368/themen/"
 *    Copy: "/themen/"
 * 
 * 3. Use that exact path as the key in this file:
 *    "/themen/": {
 *        "en": { "label": "Themes", "url": "/en/themes/" },
 *        "de": { "label": "Themen", "url": "/de/themen/" }
 *    }
 * 
 * 4. In the translation values, ADD the language prefix:
 *    - English: "/en/themes/" (added /en/ prefix)
 *    - German: "/de/themen/" (added /de/ prefix)
 * 
 * COMMON MISTAKE:
 * ❌ Don't use language prefixes in the KEY:
 *    "/en/themen/": { ... }  // WRONG!
 *    
 * ✅ Use language prefixes only in the VALUES:
 *    "/themen/": {
 *        "en": { "url": "/en/themes/" }  // RIGHT!
 *    }
 * 
 * WHY?
 * - The KEY must match what Ghost Admin outputs (no prefix)
 * - The VALUES tell where to redirect for each language (with prefix)
 * - JavaScript matches the KEY, then uses the appropriate VALUE
 * 
 * DEBUGGING:
 * If you get double prefixes like /en/en/themes/:
 * 1. Check Ghost Admin URLs have NO language prefix
 * 2. Check translation KEYs have NO language prefix  
 * 3. Check translation VALUES DO have language prefix
 * 4. Open browser console and check: window.navigationTranslations
 */

/**
 * Helper function to get translated navigation item
 */
window.getNavTranslation = function(url, lang) {
    var pathname = url;
    
    // Extract pathname if full URL is provided
    try {
        var urlObj = new URL(url, window.location.origin);
        pathname = urlObj.pathname;
    } catch (e) {
        // Already a pathname
    }
    
    // Strip any existing language prefix (e.g., /en/themes/ -> /themes/)
    var availableLangs = window.MultiLang ? window.MultiLang.config.availableLangs : ['en', 'de'];
    for (var i = 0; i < availableLangs.length; i++) {
        var langCode = availableLangs[i];
        var prefix = '/' + langCode + '/';
        if (pathname.indexOf(prefix) === 0) {
            pathname = pathname.substring(prefix.length - 1); // Remove prefix but keep leading slash
            break;
        }
    }
    
    // Normalize pathname (ensure trailing slash for non-root paths)
    if (pathname !== '/' && !pathname.endsWith('/')) {
        pathname += '/';
    }
    
    // Check if translation exists
    if (window.navigationTranslations && window.navigationTranslations[pathname]) {
        var translation = window.navigationTranslations[pathname][lang];
        if (translation) {
            return translation;
        }
    }
    
    // Fallback: return with language prefix added to cleaned pathname
    return {
        label: null, // Use original label
        url: pathname === '/' ? '/' : '/' + lang + pathname
    };
};